// Alvanex — product page gallery (thumbnails, swipe, zoom) and mobile sticky add-to-cart.
// Vanilla JS, no dependencies. Content is never hidden behind JS — this only enhances
// an already-functional scroll-snap gallery and an already-submittable form.

(function () {
  function initGallery(root) {
    var track = root.querySelector('[data-gallery-track]');
    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-gallery-slide]'));
    var dots = Array.prototype.slice.call(root.querySelectorAll('[data-gallery-dot]'));
    var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-gallery-thumb]'));
    var prevBtn = root.querySelector('[data-gallery-prev]');
    var nextBtn = root.querySelector('[data-gallery-next]');
    if (!track || slides.length === 0) return;

    var activeIndex = 0;

    function setActive(index) {
      activeIndex = index;
      slides.forEach(function (slide, i) {
        slide.classList.toggle('is-active', i === index);
      });
      dots.forEach(function (dot, i) {
        dot.classList.toggle('is-active', i === index);
      });
      thumbs.forEach(function (thumb, i) {
        thumb.classList.toggle('is-active', i === index);
      });
    }

    function goTo(index, behavior) {
      if (index < 0) index = slides.length - 1;
      if (index >= slides.length) index = 0;
      var target = slides[index];
      track.scrollTo({ left: target.offsetLeft, behavior: behavior || 'smooth' });
    }

    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        goTo(parseInt(dot.dataset.index, 10));
      });
    });
    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        goTo(parseInt(thumb.dataset.index, 10));
      });
    });
    if (prevBtn) prevBtn.addEventListener('click', function () { goTo(activeIndex - 1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { goTo(activeIndex + 1); });

    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              var idx = slides.indexOf(entry.target);
              if (idx > -1) setActive(idx);
            }
          });
        },
        { root: track, threshold: 0.6 }
      );
      slides.forEach(function (slide) { observer.observe(slide); });
    }

    function goToMediaId(mediaId) {
      if (!mediaId) return;
      var idx = slides.findIndex(function (slide) { return slide.getAttribute('data-media-id') === String(mediaId); });
      if (idx > -1) goTo(idx);
    }

    // Click-to-zoom (desktop and mobile alike — tap opens the same overlay).
    var overlay = root.querySelector('[data-gallery-zoom-overlay]');
    var overlayImg = overlay ? overlay.querySelector('[data-gallery-zoom-img]') : null;
    var overlayClose = overlay ? overlay.querySelector('[data-gallery-zoom-close]') : null;

    function openZoom(index) {
      if (!overlay || !overlayImg) return;
      var slide = slides[index];
      var fullSrc = slide.getAttribute('data-full-src');
      if (fullSrc) overlayImg.src = fullSrc;
      overlay.hidden = false;
      requestAnimationFrame(function () {
        overlay.classList.add('is-open');
      });
      document.body.style.overflow = 'hidden';
    }
    function closeZoom() {
      if (!overlay) return;
      overlay.classList.remove('is-open');
      document.body.style.overflow = '';
      setTimeout(function () {
        overlay.hidden = true;
      }, 220);
    }

    root.querySelectorAll('[data-zoom-trigger]').forEach(function (trigger, i) {
      trigger.addEventListener('click', function () {
        openZoom(i);
      });
    });
    if (overlayClose) overlayClose.addEventListener('click', closeZoom);
    if (overlay) {
      overlay.addEventListener('click', function (e) {
        if (e.target === overlay) closeZoom();
      });
    }
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && overlay && !overlay.hidden) closeZoom();
    });

    setActive(0);

    return { goToMediaId: goToMediaId };
  }

  function initQuantity(form) {
    var input = form.querySelector('[data-qty-input]');
    var decrease = form.querySelector('[data-qty-decrease]');
    var increase = form.querySelector('[data-qty-increase]');
    if (!input) return;
    if (decrease) {
      decrease.addEventListener('click', function () {
        var val = Math.max(1, (parseInt(input.value, 10) || 1) - 1);
        input.value = val;
      });
    }
    if (increase) {
      increase.addEventListener('click', function () {
        var val = Math.max(1, (parseInt(input.value, 10) || 1) + 1);
        input.value = val;
      });
    }
  }

  function renderSpecs(specs) {
    var container = document.querySelector('[data-specs-variant]');
    if (!container) return;
    if (!specs || specs.length === 0) {
      container.innerHTML = '';
      container.hidden = true;
      return;
    }
    container.hidden = false;
    container.innerHTML = specs.map(function (row) {
      return '<div class="pdp-detail__item"><dt>' + row.label + '</dt><dd>' + row.value + '</dd></div>';
    }).join('');
  }

  function pulse(el) {
    if (!el) return;
    el.classList.remove('is-updated');
    // Force reflow so the animation can retrigger on rapid consecutive switches.
    void el.offsetWidth;
    el.classList.add('is-updated');
  }

  // Keeps every bundle-tier card (Bundle Selector) and comparison row in sync
  // with the Length the shopper just selected on THIS product. Each card/row
  // carries its own tier's real variant data (data-variants, one entry per
  // Length) rendered server-side — this only picks the matching entry and
  // updates the DOM; it never invents or hardcodes a price. Elements whose
  // tier has only one variant (no Length option, e.g. Spot Lights) are
  // skipped entirely since there's nothing to synchronize.
  function updateBundleCardsForLength(lengthValue) {
    if (!lengthValue) return;
    document.querySelectorAll('[data-bundle-card]').forEach(function (el) {
      var raw = el.getAttribute('data-variants');
      if (!raw) return;
      var variants;
      try {
        variants = JSON.parse(raw);
      } catch (e) {
        return;
      }
      if (!variants || variants.length < 2) return;
      var match = variants.filter(function (v) {
        return v.options.indexOf(lengthValue) > -1;
      })[0];
      if (!match) return;

      var priceEl = el.querySelector('.pdp-bundles__price-value, .pdp-compare__price-value');
      if (priceEl) priceEl.textContent = match.price;

      var compareEl = el.querySelector('.pdp-bundles__compare, .pdp-compare__compare');
      if (compareEl) {
        if (match.comparePrice) {
          compareEl.textContent = match.comparePrice;
          compareEl.hidden = false;
        } else {
          compareEl.hidden = true;
        }
      }

      var savingsEl = el.querySelector('.pdp-bundles__savings');
      var dashEl = el.querySelector('.pdp-compare__dash');
      if (savingsEl) {
        if (match.savingsPercent > 0) {
          savingsEl.textContent = 'Save ' + match.savingsPercent + '%';
          savingsEl.hidden = false;
          if (dashEl) dashEl.hidden = true;
        } else {
          savingsEl.hidden = true;
          if (dashEl) dashEl.hidden = false;
        }
      }

      var unitPriceEl = el.querySelector('.pdp-bundles__unit-price');
      if (unitPriceEl && match.unitPrice) unitPriceEl.textContent = match.unitPrice + '/light';

      var unitPriceCell = el.querySelector('.pdp-compare__unit-price');
      if (unitPriceCell && match.unitPrice) unitPriceCell.textContent = match.unitPrice;

      // Keep each card/row's own link (and its prefetch hint) pointed at the
      // matching variant, so clicking through to another tier after switching
      // Length still lands on the right one.
      if (match.url) {
        if (el.tagName === 'A') {
          el.href = match.url;
          el.setAttribute('data-prefetch-href', match.url);
        }
        var innerLink = el.querySelector('.pdp-compare__link');
        if (innerLink) {
          innerLink.href = match.url;
          innerLink.setAttribute('data-prefetch-href', match.url);
        }
      }
    });
  }

  function initVariantPicker(root, form, gallery) {
    var picker = form.querySelector('[data-variant-picker]');
    var dataScript = form.querySelector('[data-product-variants]');
    if (!picker || !dataScript) return;

    var variants;
    try {
      variants = JSON.parse(dataScript.textContent);
    } catch (e) {
      return;
    }

    var idInput = form.querySelector('[data-variant-id]');
    var priceEl = root.querySelector('[data-price]');
    var comparePriceEl = root.querySelector('[data-compare-price]');
    var savingsEl = root.querySelector('[data-savings]');
    var unitPriceEl = root.querySelector('[data-unit-price]');
    var skuEl = root.querySelector('[data-sku]');
    var skuValueEl = root.querySelector('[data-sku-value]');
    var trustEl = root.querySelector('[data-trust]');
    var addToCartBtn = form.querySelector('[data-add-to-cart]');
    var addToCartText = form.querySelector('[data-add-to-cart-text]');
    var stickyPriceEl = document.querySelector('[data-sticky-price]');
    var stickyAddBtn = document.querySelector('[data-sticky-add-to-cart]');
    var stickyAddText = document.querySelector('[data-sticky-add-to-cart-text]');

    var optionPositions = [];
    Array.prototype.forEach.call(picker.querySelectorAll('[data-option-position]'), function (el) {
      var pos = el.getAttribute('data-option-position');
      if (optionPositions.indexOf(pos) === -1) optionPositions.push(pos);
    });
    var radios = Array.prototype.slice.call(picker.querySelectorAll('input[data-option-position]'));

    function findMatch() {
      var selected = optionPositions.map(function (pos) {
        var checked = picker.querySelector('input[data-option-position="' + pos + '"]:checked');
        return checked ? checked.value : null;
      });
      return variants.filter(function (variant) {
        return selected.every(function (value, i) { return variant.options[i] === value; });
      })[0];
    }

    function applyVariant(variant) {
      if (!variant) return;
      if (idInput) idInput.value = variant.id;
      if (priceEl) { priceEl.textContent = variant.price; pulse(priceEl); }
      if (savingsEl) {
        if (variant.savingsPercent > 0) {
          savingsEl.textContent = 'Save ' + variant.savingsPercent + '%';
          savingsEl.hidden = false;
        } else {
          savingsEl.hidden = true;
        }
      }
      if (comparePriceEl) {
        if (variant.comparePrice) {
          comparePriceEl.textContent = variant.comparePrice;
          comparePriceEl.hidden = false;
        } else {
          comparePriceEl.hidden = true;
        }
      }
      if (unitPriceEl) {
        if (variant.unitPrice) {
          unitPriceEl.textContent = variant.unitPrice + '/light';
          unitPriceEl.hidden = false;
          pulse(unitPriceEl);
        } else {
          unitPriceEl.hidden = true;
        }
      }
      if (stickyPriceEl) stickyPriceEl.textContent = variant.price;

      if (skuEl && skuValueEl) {
        if (variant.sku) {
          skuValueEl.textContent = variant.sku;
          skuEl.hidden = false;
        } else {
          skuEl.hidden = true;
        }
      }

      if (trustEl) trustEl.hidden = !variant.available;

      if (gallery && gallery.goToMediaId) gallery.goToMediaId(variant.featuredImageId);

      renderSpecs(variant.specs);

      [
        [addToCartBtn, addToCartText],
        [stickyAddBtn, stickyAddText]
      ].forEach(function (pair) {
        var btn = pair[0], text = pair[1];
        if (!btn) return;
        btn.disabled = !variant.available;
        if (text) text.textContent = variant.available ? 'Add to Bag' : 'Coming Soon';
      });
    }

    radios.forEach(function (radio) {
      radio.addEventListener('change', function () {
        applyVariant(findMatch());
        var lengthRadio = picker.querySelector('input[data-option-name="Length"]:checked');
        if (lengthRadio) updateBundleCardsForLength(lengthRadio.value);
      });
    });
  }

  // Bundle-tier and comparison links are real navigations to a different
  // product page (each pack size is its own product). We don't clone gallery/
  // price state across products client-side — that would duplicate the
  // variant-picker logic per product and add real fragility for a marginal
  // perceived-speed gain. Instead, prefetch the target page on hover/focus so
  // the click still feels instant, while the link itself is fully functional
  // (and the only mechanism) if JavaScript never runs.
  function initBundlePrefetch() {
    var prefetched = {};
    function prefetch(href) {
      if (!href || prefetched[href]) return;
      prefetched[href] = true;
      var link = document.createElement('link');
      link.rel = 'prefetch';
      link.href = href;
      document.head.appendChild(link);
    }
    document.querySelectorAll('[data-prefetch-href]').forEach(function (el) {
      var href = el.getAttribute('data-prefetch-href');
      el.addEventListener('mouseenter', function () { prefetch(href); }, { once: true });
      el.addEventListener('focus', function () { prefetch(href); }, { once: true });
      el.addEventListener('touchstart', function () { prefetch(href); }, { once: true, passive: true });
    });
  }

  function initStickyBar(root) {
    // The sticky bar is intentionally a sibling of the product grid (not a
    // descendant), so it can't be found via root.querySelector — it's a
    // single page-level element, so look it up from the document instead.
    var bar = document.querySelector('[data-sticky-bar]');
    var anchor = root.querySelector('[data-purchase-anchor]');
    if (!bar || !anchor || !('IntersectionObserver' in window)) return;

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          bar.classList.toggle('is-visible', !entry.isIntersecting);
        });
      },
      { threshold: 0 }
    );
    observer.observe(anchor);
  }

  document.querySelectorAll('[data-product-page]').forEach(function (root) {
    var galleryEl = root.querySelector('[data-gallery]');
    var form = root.querySelector('#ProductForm');
    var galleryApi = galleryEl ? initGallery(galleryEl) : null;
    if (form) initQuantity(form);
    if (form) initVariantPicker(root, form, galleryApi);
    initStickyBar(root);
  });
  initBundlePrefetch();
})();
